import BonusList from "./EarlyBirdList";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import BonusTabs from "./BonusTabs";

export default {
  list: BonusTabs,
  icon: MonetizationOnIcon,
};
